(function () {
  const SELECTORS = {
    quickCart: '.quick-cart[data-section-id]',
    cartWrapper: '.quick-cart__wrapper',
    discountFormRoot: '[data-cart-discount-form-root]',
    discountInput: '[data-cart-discount-input]',
    discountApply: '[data-cart-discount-apply]',
    discountCode: '[data-discount-code]',
    discountRemove: '[data-cart-discount-remove]',
    discountError: '[data-cart-discount-error]',
  };

  function getUpdateUrl() {
    const routes = window.theme && window.theme.routes && window.theme.routes.cart;
    const base = routes && routes.update ? routes.update : '/cart/update';
    return base.indexOf('.js') === base.length - 3 ? base : base + '.js';
  }

  function getCartBaseUrl() {
    const routes = window.theme && window.theme.routes && window.theme.routes.cart;
    return routes && routes.base ? routes.base : '/cart';
  }

  function normalizeCode(code) {
    return code.trim().toUpperCase();
  }

  function updateInnerHTML(selector, doc) {
    const updated = doc.querySelector(selector);
    const current = document.querySelector(selector);
    if (updated && current) {
      current.innerHTML = updated.innerHTML;
    }
  }

  function refreshQuickCartSection() {
    const quickCart = document.querySelector(SELECTORS.quickCart);
    if (!quickCart) return Promise.resolve();

    const sectionId = quickCart.getAttribute('data-section-id');
    const url = getCartBaseUrl() + '?section_id=' + sectionId;

    return fetch(url, { credentials: 'include' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const container = document.createElement('div');
        container.innerHTML = html;
        const wrapper = SELECTORS.cartWrapper;

        updateInnerHTML(wrapper + ' .quick-cart__items', container);
        updateInnerHTML(wrapper + ' .quick-cart__heading sup', container);
        updateInnerHTML(wrapper + ' .quick-cart__footer-subtotal-wrapper', container);
        updateInnerHTML(wrapper + ' ' + SELECTORS.discountFormRoot, container);

        document.dispatchEvent(new CustomEvent('quick-cart:discount-refreshed'));
      });
  }

  function getExistingDiscounts() {
    const quickCart = document.querySelector(SELECTORS.quickCart);
    if (!quickCart) return [];

    const codes = [];
    quickCart.querySelectorAll(SELECTORS.discountCode).forEach(function (node) {
      const code = node.getAttribute('data-discount-code');
      if (code) codes.push(code);
    });
    return codes;
  }

  function showDiscountError(root) {
    const error = root.querySelector(SELECTORS.discountError);
    if (error) error.hidden = false;
  }

  function hideDiscountError(root) {
    const error = root.querySelector(SELECTORS.discountError);
    if (error) error.hidden = true;
  }

  function discountApplicationMatchesCode(application, normalizedCode) {
    if (!application || !application.title) return false;
    return normalizeCode(application.title) === normalizedCode;
  }

  function isDiscountAppliedInCart(cart, code) {
    const normalizedCode = normalizeCode(code);
    if (!normalizedCode) return false;

    const discountCodeEntries = cart.discount_codes || [];
    for (let i = 0; i < discountCodeEntries.length; i++) {
      const entry = discountCodeEntries[i];
      if (entry.code && normalizeCode(entry.code) === normalizedCode && entry.applicable === true) {
        return true;
      }
    }

    const cartLevelDiscounts = cart.cart_level_discount_applications || [];
    for (let j = 0; j < cartLevelDiscounts.length; j++) {
      const application = cartLevelDiscounts[j];
      if (
        application.type === 'discount_code' &&
        discountApplicationMatchesCode(application, normalizedCode)
      ) {
        return true;
      }
    }

    const items = cart.items || [];
    for (let k = 0; k < items.length; k++) {
      const allocations = items[k].line_level_discount_allocations || [];
      for (let l = 0; l < allocations.length; l++) {
        const application = allocations[l].discount_application;
        if (
          application &&
          application.type === 'discount_code' &&
          discountApplicationMatchesCode(application, normalizedCode)
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function isDiscountVisibleInDrawer(code) {
    const normalizedCode = normalizeCode(code);
    return getExistingDiscounts().some(function (existingCode) {
      return normalizeCode(existingCode) === normalizedCode;
    });
  }

  function applyDiscountCodes(codes) {
    return fetch(getUpdateUrl(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ discount: codes.join(',') }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart update failed');
      }
      return response.json();
    });
  }

  function applyDiscountFromRoot(root) {
    const input = root.querySelector(SELECTORS.discountInput);
    if (!input) return;

    const code = input.value.trim();
    if (!code) return;

    const normalizedCode = normalizeCode(code);
    const existing = getExistingDiscounts();

    if (
      existing.some(function (existingCode) {
        return normalizeCode(existingCode) === normalizedCode;
      })
    ) {
      input.value = '';
      hideDiscountError(root);
      return;
    }

    hideDiscountError(root);

    applyDiscountCodes(existing.concat([code]))
      .then(function (cart) {
        return refreshQuickCartSection().then(function () {
          const applied =
            isDiscountAppliedInCart(cart, code) || isDiscountVisibleInDrawer(code);

          if (applied) {
            hideDiscountError(root);
            input.value = '';
            return;
          }

          showDiscountError(root);
        });
      })
      .catch(function () {
        showDiscountError(root);
      });
  }

  function handleApplyClick(event) {
    const button = event.target.closest(SELECTORS.discountApply);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const root = button.closest(SELECTORS.discountFormRoot);
    if (!root) return;

    applyDiscountFromRoot(root);
  }

  function handleInputKeydown(event) {
    if (event.key !== 'Enter') return;

    const input = event.target.closest(SELECTORS.discountInput);
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();

    const root = input.closest(SELECTORS.discountFormRoot);
    if (!root) return;

    applyDiscountFromRoot(root);
  }

  function handleRemove(event) {
    const button = event.target.closest(SELECTORS.discountRemove);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const discountRow = button.closest(SELECTORS.discountCode);
    const root = document.querySelector(SELECTORS.discountFormRoot);
    if (!discountRow) return;

    const code = discountRow.getAttribute('data-discount-code');
    if (!code) return;

    const existing = getExistingDiscounts();
    const normalizedCode = normalizeCode(code);
    const nextCodes = existing.filter(function (existingCode) {
      return normalizeCode(existingCode) !== normalizedCode;
    });

    if (root) hideDiscountError(root);

    applyDiscountCodes(nextCodes)
      .then(function () {
        return refreshQuickCartSection();
      })
      .catch(function () {
        if (root) showDiscountError(root);
      });
  }

  document.addEventListener('click', handleApplyClick);
  document.addEventListener('keydown', handleInputKeydown);
  document.addEventListener('click', handleRemove);
})();
